import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
import { UserStore } from "@/stores/modules/user.ts";
import { ARTICLE_TYPE } from "@supplier/meta";
const manageCenterRouter: RouteRecordRaw[] = [
    {
        path: "/manageCenter",
        name: "ManageCenter",
        redirect: "/manageCenter/systemManage/role",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "系统设置",
            icon: "icon-pingtaiguanli"
        },
        children: [
            {
                path: "backendAccount",
                name: "BackendAccount",
                component: () => import("@/views/pages/manageCenter/systemManage/backendAccount/index.vue"),
                meta: {
                    title: "账号管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_USER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_USER_W"
                        }
                    ],
                    activeMenu: "BackendAccount"
                }
            },
            {
                path: "backendAccount/add",
                name: "BackendAccountAdd",
                component: () => import("@/views/pages/manageCenter/systemManage/backendAccount/add/index.vue"),
                meta: {
                    title: "新增账号",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_USER_W"
                        }
                    ],
                    activeMenu: "BackendAccount"
                }
            },
            {
                path: "backendAccount/edit/:id",
                name: "BackendAccountEdit",
                component: () => import("@/views/pages/manageCenter/systemManage/backendAccount/add/index.vue"),
                meta: {
                    title: "编辑账号",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_USER_W"
                        }
                    ],
                    activeMenu: "BackendAccount"
                }
            },
            {
                path: "authentication",
                name: "Authentication",
                component: () => import("@/views/pages/manageCenter/authentication/index.vue"),
                meta: {
                    title: "认证",
                    hidden: ({ userStore }: { userStore: UserStore }) => {
                        return !userStore.isSAAS;
                    },
                    isNotShowHeader: true,
                    activeMenu: "Authentication",
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            },
            {
                path: "role",
                name: "Role",
                component: () => import("@/views/pages/manageCenter/systemManage/role/index.vue"),
                meta: {
                    title: "角色权限",
                    subTitle: [
                        "角色说明：角色是不同权限的集合，通过将角色分配给用户，实现系统在用户使用过程中基于角色的权限控制。"
                    ],
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ROLE_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_ROLE_W"
                        }
                    ],
                    activeMenu: "Role"
                }
            },
            {
                path: "role/add",
                name: "RoleAdd",
                component: () => import("@/views/pages/manageCenter/systemManage/role/roleDetail.vue"),
                meta: {
                    title: "新增角色",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_ROLE_W"
                        }
                    ],
                    activeMenu: "Role"
                }
            },
            {
                path: `role/detail/:id`,
                name: "RoleDetail",
                component: () => import("@/views/pages/manageCenter/systemManage/role/roleDetail.vue"),
                meta: {
                    title: "角色详情",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ROLE_R"
                        }
                    ],
                    activeMenu: "Role"
                }
            },
            {
                path: `role/edit/:id`,
                name: "RoleEdit",
                component: () => import("@/views/pages/manageCenter/systemManage/role/roleDetail.vue"),
                meta: {
                    title: "编辑角色",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_ROLE_W"
                        }
                    ],
                    activeMenu: "Role"
                }
            },
            {
                path: "supplierAbout",
                name: "SupplierAbout",
                meta: {
                    title: "关于我们",
                    hidden: ({ userStore }: { userStore: UserStore }) => {
                        return userStore.isSAAS;
                    }
                },
                children: [
                    {
                        path: "privacyAgreement",
                        name: "PrivacyAgreement",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/article/index.vue"),
                        props: { type: ARTICLE_TYPE.PRIVACY_AGREEMENT.code },
                        meta: {
                            title: "隐私政策",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            authOptions: [
                                {
                                    label: "查看/修改",
                                    value: "ROLE_ABOUT_LY"
                                }
                            ],
                            activeMenu: "PrivacyAgreement"
                        }
                    },
                    {
                        path: "userAgreement",
                        name: "UserAgreement",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/article/index.vue"),
                        props: { type: ARTICLE_TYPE.USER_AGREEMENT.code },
                        meta: {
                            title: "用户协议",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            authOptions: [
                                {
                                    label: "查看/修改",
                                    value: "ROLE_ABOUT_LY"
                                }
                            ],
                            activeMenu: "UserAgreement"
                        }
                    }
                ]
            },
            {
                path: "platBankAccount",
                name: "PlatBankAccount",
                component: () => import("@/views/pages/manageCenter/platBankAccount/index.vue"),
                meta: {
                    title: "银行账号",
                    activeMenu: "PlatBankAccount",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_ACCOUNT_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "goodsManage",
                name: "GoodsManage",
                component: () => import("@/views/pages/manageCenter/goodsManage/index.vue"),
                meta: {
                    title: "货物管理",
                    activeMenu: "GoodsManage",
                    pageType: PAGE_TYPE.LIST.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_CARGO_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_CARGO_W"
                        }
                    ]
                }
            },
            {
                path: "goodsManage/add",
                name: "GoodsManageAdd",
                component: () => import("@/views/pages/manageCenter/goodsManage/form.vue"),
                meta: {
                    title: "新增货物类型",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "GoodsManage",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_CARGO_W"
                        }
                    ]
                }
            },
            {
                path: "goodsManage/edit/:id",
                name: "GoodsManageEdit",
                component: () => import("@/views/pages/manageCenter/goodsManage/form.vue"),
                meta: {
                    title: "编辑货物类型",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "GoodsManage",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_CARGO_W"
                        }
                    ]
                }
            },
            {
                path: "warehouseManagement",
                name: "WarehouseManagement",
                component: () => import("@/views/pages/storageManagement/warehouseManagement/index.vue"),
                meta: {
                    title: "仓库管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_DEPOT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_DEPOT_W"
                        }
                    ]
                }
            },
            {
                path: "warehouse/add",
                name: "WarehouseAdd",
                component: () => import("@/views/pages/storageManagement/warehouseManagement/add.vue"),
                meta: {
                    title: "新增仓库",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "WarehouseManagement",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_DEPOT_W"
                        }
                    ]
                }
            },
            {
                path: "warehouse/edit/:id",
                name: "WarehouseEdit",
                component: () => import("@/views/pages/storageManagement/warehouseManagement/add.vue"),
                meta: {
                    title: "编辑仓库",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "WarehouseManagement",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_DEPOT_W"
                        }
                    ]
                }
            },
            {
                path: "warehouse/detail/:id",
                name: "WarehouseDetail",
                component: () => import("@/views/pages/storageManagement/warehouseManagement/detail.vue"),
                meta: {
                    title: "仓库详情",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    activeMenu: "WarehouseManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_DEPOT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_DEPOT_W"
                        }
                    ]
                }
            },
            {
                path: "msgSetting",
                name: "MsgSetting",
                component: () => import("@/views/pages/manageCenter/msgSetting/index.vue"),
                meta: {
                    title: "消息设置",
                    activeMenu: "MsgSetting",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_MESSAGE_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "sealManage",
                name: "SealManage",
                component: () => import("@/views/pages/manageCenter/sealManagement/index.vue"),
                meta: {
                    title: "印章管理",
                    isNotShowHeader: true,
                    activeMenu: "SealManage",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SEAL"
                        }
                    ]
                }
            },
            {
                path: "sealAdd",
                name: "SealAdd",
                component: () => import("@/views/pages/manageCenter/sealManagement/add.vue"),
                meta: {
                    title: "新增印章",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "SealManage",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SEAL"
                        }
                    ]
                }
            },
            {
                path: "sealEdit",
                name: "SealEdit",
                component: () => import("@/views/pages/manageCenter/sealManagement/edit.vue"),
                meta: {
                    title: "编辑印章",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "SealManage",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SEAL"
                        }
                    ]
                }
            },
            {
                path: "sealDetail",
                name: "SealDetail",
                component: () => import("@/views/pages/manageCenter/sealManagement/detail.vue"),
                meta: {
                    title: "印章详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "SealManage",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SEAL"
                        }
                    ]
                }
            }
        ]
    }
];

export default manageCenterRouter;
